import Device from "@/classes/Device";
import { MutationTree } from "vuex";
import { StateInterface } from "./state";

const mutation: MutationTree<StateInterface> = {
  /**
   * overrites state with given device groups
   */
  setDeviceGroups: (state, deviceGroups) => (state.deviceGroups = deviceGroups),
  /**
   * adds a new device group
   */
  addDeviceGroup: (state, deviceGroup) => state.deviceGroups.push(deviceGroup),
  /**
   * deletes group by given id (not a device)
   * @param deviceGroupGID group id to delete
   */
  deleteDeviceGroup: (state, deviceGroupGID) => {
    const index = state.deviceGroups.findIndex(
      (group) => group.GID === deviceGroupGID
    );
    state.deviceGroups.splice(index, 1);
  },
  // changeDeviceGroupAssignment: (state, { deviceId, groupId }) => {
  //   console.log(state.deviceGroups);
  //   const groupToAdd = state.deviceGroups.find(
  //     (group) => (group.GID = groupId)
  //   );
  //   console.log(groupToAdd);

  //   if (groupToAdd) {
  //     let device = null;
  //     let groupToRemove = null;

  //     for (let i = 0; i < state.deviceGroups.length; i++) {
  //       const group = state.deviceGroups[i];
  //       let tempDevice = group.devices.find((dev) => dev.DID === deviceId);

  //       if (tempDevice) {
  //         device = tempDevice;
  //         groupToRemove = group;
  //         break;
  //       }
  //     }

  //     if (device && groupToRemove) {
  //       groupToAdd.devices.splice(0, 0, device);
  //       groupToRemove.devices.splice(groupToRemove.devices.indexOf(device), 1);
  //     }
  //   }
  // },

  /**
   * changes the device settings/config
   * @param deviceSettings settings object like in Device class
   * @see Device.toDeviceSettingsObject()
   */
  changeDeviceConfig(state, deviceSettings) {
    for (let i = 0; i < state.deviceGroups.length; i++) {
      const group = state.deviceGroups[i];
      const tempDev = group.devices.find(
        (dev) => dev.IDENTIFIER === deviceSettings.id
      );

      if (tempDev) {
        tempDev.updateDeviceSettings(deviceSettings);
        break;
      }
    }
  },

  changeDeviceConnectpath(state, device: Device) {
    for (let i = 0; i < state.deviceGroups.length; i++) {
      const group = state.deviceGroups[i];
      const tempDev = group.devices.find(
        (dev) => dev.IDENTIFIER === device.IDENTIFIER
      );

      if (tempDev) {
        tempDev.CONNECTPATH = device.CONNECTPATH;
        break;
      }
    }
  },
  /**
   * updates device name
   */
  editDevice: (state, { deviceID, deviceName }) => {
    for (let i = 0; i < state.deviceGroups.length; i++) {
      const group = state.deviceGroups[i];

      const tempDev = group.devices.find((dev) => dev.DID === deviceID);

      if (tempDev) {
        tempDev.NAME = deviceName;
        break;
      }
    }
  },
  /**
   * deletes a device by its id (not the group)
   */
  deleteDevice: (state, DID) => {
    state.deviceGroups.forEach((group) => {
      const index = group.devices.findIndex((device) => device.DID === DID);
      group.devices.splice(index, 1);
      return;
    });
  },

  /**
   * updates the playlist heredity in store
   */
  updatePlaylistHeredity: (state, payload: { deviceId: number, playlistHeredity: string } ) => {
    state.deviceGroups.forEach((group) => {
      const index = group.devices.findIndex((device) => device.DID === payload.deviceId);
      if(index >= 0) group.devices[index].playlistHeredity = payload.playlistHeredity;
      return true;
    });
  },

  /**
   * updates the group name in store
   */
   updateGroupName: (state, payload: { accId: number, groupId: number, groupName: string } ) => {
    const index = state.deviceGroups.findIndex((group) => group.GID === payload.groupId );
    state.deviceGroups[index].GNAME = payload.groupName;
    return true;
  },

  /**
   * updates the group name in store
   */
   updateTargetVersions: (state, data: { deviceId: number, versionmp: string, versionsm: string } ) => {
    let i1;
    let i2;
    state.deviceGroups.forEach((group, index) => {
      group.devices.forEach((device, index2) => {
        if(device.DID === data.deviceId) {
          i1=index;
          i2=index2;
        }
      });
    });
    state.deviceGroups[i1].devices[i2].TARGETVERSION = data.versionmp;
    state.deviceGroups[i1].devices[i2].TARGETVERSIONSM = data.versionsm;
    return true;
  },

  /**
   * updates the group orientation in store
   */
   updateGroupSettings: (state, payload: { groupId: number, settings: { orientation: string } } ) => {
    const index = state.deviceGroups.findIndex((group) => group.GID === payload.groupId );
    state.deviceGroups[index].ORIENTATION = payload.settings.orientation;
    return true;
  },

};

export default mutation;
